import { HeartHandshake, Search, MessagesSquare, ShieldCheck } from "lucide-react";

const pillars = [
  {
    icon: Search,
    title: "Sguardo clinico, non solo esecuzione",
    text: "Ogni esame nasce da una domanda clinica precisa. Studio la storia del paziente e l'indicazione prima di iniziare, così l'immagine diventa una risposta — non solo una fotografia.",
  },
  {
    icon: HeartHandshake,
    title: "Empatia come metodo",
    text: "Lavorare in un ente come la Casa di Cura Palazzolo significa accogliere le persone in un momento di fragilità. L'empatia non è un di più: è parte integrante della cura.",
  },
  {
    icon: MessagesSquare,
    title: "Referti chiari e dialoganti",
    text: "Spiego ciò che vedo in un linguaggio comprensibile, indicando con precisione cosa è rilevante, cosa è atteso e quali eventuali approfondimenti sono utili.",
  },
  {
    icon: ShieldCheck,
    title: "Aggiornamento continuo",
    text: "Formazione internazionale, collaborazione con sviluppatori di intelligenza artificiale e partecipazione a commissioni cliniche per restare allineata alle migliori evidenze.",
  },
];

export default function Approach() {
  return (
    <section
      id="approccio"
      data-testid="approach-section"
      className="py-24 lg:py-32 bg-[#FAFAF9] border-t border-stone-200"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16">
        <div className="max-w-3xl">
          <span className="eyebrow">Approccio</span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-stone-900 leading-[1.1]">
            Oltre il referto: ascolto e attenzione ai dettagli.
          </h2>
          <p className="mt-6 text-stone-600 leading-relaxed text-lg">
            La radiologia, per come la intendo, non si esaurisce nella refertazione di un'immagine. È un atto
            clinico che mette in dialogo competenze tecniche, conoscenza della medicina e relazione con la persona.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-5 lg:gap-6">
          {pillars.map((p) => (
            <div
              key={p.title}
              data-testid={`approach-pillar-${p.title.split(" ")[0].toLowerCase()}`}
              className="group rounded-2xl border border-stone-200 bg-white p-7 lg:p-8 hover:shadow-md transition-all duration-300"
            >
              <div className="flex items-start gap-5">
                <div className="shrink-0 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#E9F0EE] text-[#3E615B] group-hover:bg-[#3E615B] group-hover:text-white transition-colors">
                  <p.icon size={20} />
                </div>
                <div>
                  <h3 className="font-display text-xl font-medium text-stone-900">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-stone-600 leading-relaxed">{p.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
